import $http from './http';

// 文件上传
export const uploadFile = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/system/upload-file/' + id : '/v1/system/upload-file',
        method == 'get' ? { params: params } : params,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    );
};

// 图片上传
export const uploadImg = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/system/upload-img/' + id : '/v1/system/upload-img',
        method == 'get' ? { params: params } : params,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    );
};

// 图片文件删除
export const delFile = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/system/del-file/' + id : '/v1/system/del-file',
        method == 'get' ? { params: params } : params
    );
};